import { UNSTABLE_ToastQueue as ToastQueue } from 'react-aria-components';

export type ToastContent = {
	type: 'error' | 'success' | 'info';
	title: string;
	description?: string;
	// Backend request ID, shown so the user can quote it when reporting the error.
	reference?: string;
};

export const toastQueue = new ToastQueue<ToastContent>({ maxVisibleToasts: 5 });
